export const BG_ARR = [
    {
        label: '尊贵蓝',
        value: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/bg1.png',
        color: '#152d69'
    },
    {
        label: '荣耀金',
        value: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/bg3.png',
        color: '#412b15'
    },
    {
        label: '经典蓝',
        value: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/bg4.png',
        color: '#0d2d63'
    },
    {
        label: '宝石蓝',
        value: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/bg2.png',
        color: '#1546aa'
    }
];

export const TAB_ARR = [
    {
        name: '认证信息',
        key: 'auth',
        logArea: 'authentication-tab'
    },
    {
        name: '其他信息',
        key: 'other',
        logArea: 'other-tab'
    },
    {
        name: '品宣图信息',
        key: 'pic',
        logArea: 'banner-tab'
    },
    {
        name: '亲办案件',
        key: 'case',
        logArea: 'case-tab'
    },
    {
        name: '百家号信息',
        key: 'bjh',
        logArea: 'bjh-tab'
    }
];

export const CASE_ARR = [
    'https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/case1.png',
    'https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/case2.png',
    'https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/case3.png'
];

export const STATUS_MAP = {
    '2': {
        value: 'warning',
        label: '认证信息审核中'
    },
    '4': {
        value: 'success',
        label: '执业审核成功'
    },
    '6': {
        value: 'error',
        label: '认证信息审核失败'
    }
};

export const HOME_CASE_ARR = {
    '尊贵蓝': 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/preview1.png',
    '荣耀金': 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/preview22.jpg',
    '宝石蓝': 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/preview33.png',
    '经典蓝': 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/preview44.png'
};